import {
  MediaGalleryItems,
  Product
} from '@features/product/components/Collection/Collection.types';
import { Product as GlobalProduct, ProductImage } from '@features/product/typings';

export const getCollectionProductImageId = (product: GlobalProduct | Product | null): string => {
  const images = (product?.mediaGallery?.items ?? []).filter((item): item is ProductImage =>
    Object.hasOwn(item, 'label')
  );

  if (images.length === 0) {
    return '';
  }

  return (
    findImageIdByLabel('product color detail', images) ||
    findImageIdByLabel('Main Image', images) ||
    ''
  );
};

export const findImageIdByLabel = (
  label: string,
  items: ProductImage[] | MediaGalleryItems[]
): string | undefined => items.find(item => 'label' in item && item.label === label)?.image.id;
